import { render } from "./VehicleInformation.vue?vue&type=template&id=70cee896"
import script from "./VehicleInformation.vue?vue&type=script&lang=js"
export * from "./VehicleInformation.vue?vue&type=script&lang=js"

import "./VehicleInformation.vue?vue&type=style&index=0&id=70cee896&lang=css"
script.render = render

export default script